module.exports = __webpack_public_path__ + "static/media/htmlIco.67b8ae82.webp";